import { SIZE } from '@app/constants'
import { SEPARATOR } from '@app/constants/separator'

import type { LntSelectOption, LntSelectProps } from '@app/components/base/Select/types'

export const commonSelectProps: LntSelectProps<number[]> = {
  showArrow: true,
  mode: 'multiple',
  size: SIZE.middle,
  strictValue: true,
  tokenSeparators: [SEPARATOR.newline]
}

export const statusOptions: LntSelectOption[] = [
  { label: 'Удаленные', value: 'DELETED' },
  { label: 'Добавленные', value: 'ADDED' },
  { label: 'Согласованные', value: 'APPROVED' },
  { label: 'Измененные', value: 'CHANGED' }
]
